module.exports = __webpack_public_path__ + "static/media/gif.1d7626e6.gif";